export default "__VITE_ASSET__$$kekDHq__"